module.exports = __webpack_public_path__ + "img/message.a1fa4f10.svg";